import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor,
  HttpRequest, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private refreshando = false;
  private refreshSubject = new BehaviorSubject<string | null>(null);

  constructor(private auth: AuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Não intercepta login nem refresh (evita loop infinito)
    if (req.url.includes('/auth/refresh') || req.url.includes('/auth/login') || req.url.includes('/auth/entrar')) {
      return next.handle(req);
    }

    const token = this.auth.getToken();
    const reqComToken = token ? this.clonarComToken(req, token) : req;

    return next.handle(reqComToken).pipe(
      catchError((erro: HttpErrorResponse) => {
        if (erro.status !== 401) {
          return throwError(() => erro);
        }

        // Se já está no meio de um refresh, aguarda o novo token
        if (this.refreshando) {
          return this.refreshSubject.pipe(
            filter(t => t !== null),
            take(1),
            switchMap(novoToken => next.handle(this.clonarComToken(req, novoToken!)))
          );
        }

        this.refreshando = true;
        this.refreshSubject.next(null);

        return this.auth.refresh().pipe(
          switchMap(res => {
            this.refreshando = false;
            this.refreshSubject.next(res.accessToken);
            // Reexecuta a requisição original com o novo token
            return next.handle(this.clonarComToken(req, res.accessToken));
          }),
          catchError(erroRefresh => {
            // Refresh falhou (token expirado ou inválido) → faz logout
            this.refreshando = false;
            this.auth.limparSessao();
            this.router.navigate(['/auth/login']);
            return throwError(() => erroRefresh);
          })
        );
      })
    );
  }

  private clonarComToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    return req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }
}